<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container m-5">

      <!-- <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6">I accept the terms & conditions.</vs-checkbox>
      </div> -->
     <div class="vx-row">

      <div class="vx-col w-full">
          <h1>Are you want to accept paying</h1>
          <br/>
           <vs-button class="mr-6" @click="submitData">{{$t('Confirm')}}</vs-button>

      </div>
    </div>

  </div>
</template>


<script>

import moduleCourseRegistration from "@/store/courseRegistration/moduleCourseRegistration.js";
export default {
  components: {

  },
  data() {
    return {


    };
  },
  computed: {


  },

  methods: {

  // this.notifyAlert("danger","Error","Please add all required contact info Email, Work Email, Mobile");
    notifyAlert(color,title,text) {
      this.$vs.notify({ time:8000,
        fixed:true,
        color: color,
        title: title,
        text: text
      });
    },
     submitData() {
         debugger;
          this.$store.dispatch("courseRegistrationList/RegisterConfirm", this.$route.query.Code).then(()=>{
              debugger;
             this.notifyAlert("success",this.$t("Done"),this.$t('ConfirmationDone'));
             this.$router.push('/');
            })

    },

  },

  created() {
  if (!moduleCourseRegistration.isRegistered) {
      this.$store.registerModule("courseRegistrationList", moduleCourseRegistration);
      moduleCourseRegistration.isRegistered = true;
    }

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
}
  .con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

  }
}
</style>
